import { useMediaQuery } from '@mui/material';
import Box from '@mui/material/Box';
import Fade from '@mui/material/Fade';
import Modal from '@mui/material/Modal';
import { ReactNode } from 'react';

interface FormModalProps {
  children: ReactNode;
  hideHeaderFooter?: boolean;
}

const desktopStyle = {
  position: 'absolute' as const,
  top: '50%',
  left: '50%',
  transform: 'translate(-50%, -50%)',
  width: 960,
  height: '90%',
  maxHeight: 716,
  bgcolor: '#fff',
  boxShadow: 24,
  outline: 'none',
  display: 'flex',
  flexDirection: 'column',
};

const mobileStyle = {
  position: 'fixed' as const,
  top: 0,
  left: 0,
  width: 1,
  height: 1,
  bgcolor: '#fff',
  outline: 'none',
  display: 'flex',
  flexDirection: 'column',
};

export const ModalLayout = ({ children }: FormModalProps) => {
  const isMobile = useMediaQuery('(max-width:960px)');

  return (
    <Modal open>
      <Fade in>
        <Box sx={isMobile ? mobileStyle : desktopStyle}>{children}</Box>
      </Fade>
    </Modal>
  );
};
